import { type PreloadFetchPolicy } from 'react-relay';

import { fg } from '@atlaskit/platform-feature-flags';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, {
	type TeamProfileCardEntryPointQuery$variables,
} from './__generated__/TeamProfileCardEntryPointQuery.graphql';

const fetchPolicyDEPRECATED: PreloadFetchPolicy = 'network-only';
const fetchPolicy: PreloadFetchPolicy = 'store-or-network';

const entryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_team-profile-card-entrypoint" */ './TeamProfileCardEntryPoint'
			),
		{
			moduleId: 'team-profile-card-entrypoint',
		},
	),
	getPreloadProps: ({ cloudId, teamId }: TeamProfileCardEntryPointQuery$variables) => ({
		queries: {
			queryRef: {
				parameters,
				variables: { cloudId, teamId },
				options: {
					fetchPolicy: fg('ptc-fix-rate-limiting-on-profile-card')
						? fetchPolicy
						: fetchPolicyDEPRECATED,
				},
			},
		},
	}),
});

export { entryPoint };
